import React from "react";

// Customizable Area Start
import {
  Box,
  Divider,
  styled,
  Typography
} from "@mui/material";
import NavigationMenu from "../../navigationmenu/src/NavigationMenu.web";
import AppFooter from "../../../components/src/AppFooter.web";
import CustomInfoDialog from "../../../components/src/CustomInfoDialog.web";
import FullPageLoader from "../../../components/src/FullPageLoader.web";
import GoogleAd from "../../../components/src/GoogleAd.web";
// Customizable Area End

import PrivacyPolicyController, {
  Props,
} from "./PrivacyPolicyController";

export default class PrivacyPolicy extends PrivacyPolicyController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    // Customizable Area Start
    const { navigation } = this.props;
    const { isLoading, isInfoDialog, privacyPolicy } = this.state

    return (
      <PrivacyPolicyStyle>
        <FullPageLoader isLoading={isLoading} />
        <NavigationMenu navigation={navigation} id={''} />
        <Box className="mainContainerBox">
          <Box className="subConatinerBox">
            <Box className="titleContainer">
              <Typography className="mainTitleTypo">Privacy Policy</Typography>
            </Box>
            <Divider />
             <div
              className="contentContainer"
              dangerouslySetInnerHTML={{ __html: privacyPolicy }}
            />
          </Box>
        </Box>
        <GoogleAd responsive format="auto" sx={{ mt: 6 }} slot="9054361576" />
        <AppFooter navigation={navigation} />
        <CustomInfoDialog
          title=""
          infoType="error"
          data-test-id="info-dialog"
          isOpen={isInfoDialog}
          handleClose={this.handleCloseInfoDialog}
        />
      </PrivacyPolicyStyle>
    );
    // Customizable Area End
  }
}

// Customizable Area Start
export const PrivacyPolicyStyle = styled(Typography)({
  "& .mainContainerBox": {
    padding: '60px',
    backgroundColor: '#EFF6FF'
  },

  "& .subConatinerBox": {
    borderRadius: '12px',
    padding: '30px',
    backgroundColor: '#FFFFFF'
  },

  "& .mainTitleTypo": {
    fontSize: '24px',
    fontWeight: '600',
    lineHeight: '29.26px',
    font: "Montserrat",
    letterSpacing: '0%',
    color: '#000000',
    marginBottom: '10px'
  },

  "& .contentContainer": {
    paddingTop: "10px",
    "& *": {
      fontFamily: "Montserrat, 'sans-serif'",
    },
    p: {
      marginBlockStart: "6px",
      marginBlockEnd: "6px",
    },
    pre: {
      padding: "5px",
      overflowX: "auto",
    },
    blockquote: {
      borderLeft: "4px solid #ccc",
      paddingLeft: "16px",
      margin: "10px 0px"
    },
    ".ql-align-center": {
      textAlign: "center",
    },
    ".ql-align-right": {
      textAlign: "right",
    },
    ".ql-align-justify": {
      textAlign: "justify",
    },
    ".ql-size-small": {
      fontSize: "12px",
    },
    ".ql-size-large": {
      fontSize: "20px",
    },
    ".ql-size-huge": {
      fontSize: "32px",
    },
  },

  "& .titleContainer": {
    alignItems: 'center',
    display: 'flex',
    padding: '5px',
    marginBottom: '5px',
    justifyContent: 'center'
  },

  "& .termsTypoText": {
    fontSize: '16px',
    font: "Montserrat",
    lineHeight: '28px',
    fontWeight: '300',
    letterSpacing: '0%',
    color: '#64748B'
  },

  "& .titletermsTypoText": {
    fontSize: '16px',
    font: "Montserrat",
    lineHeight: '19.5px',
    color: '#000000',
    fontWeight: '500'
  },

  "& .strongSubTitleTypo": {
    fontSize: '16px !important',
    font: "Montserrat",
    lineHeight: '28px !important',
    color: '#64748B',
    fontWeight: '400 !important'
  },

  "@media (max-width: 768px)": {
    "& .mainContainerBox ": {
      padding: "20px"
    },

    "& .titleContainer": {
      padding: "10px"
    },

    "& .subConatinerBox": {
      padding: "15px"
    },

    "& .mainTitleTypo": {
      lineHeight: "24px",
      fontSize: "20px",
      marginBottom: '5px'
    },

    "& .titletermsTypoText": {
      fontSize: "14px"
    },

    "& .termsTypoText": {
      lineHeight: '24px',
      fontSize: "14px"
    }
  },

  "@media (max-width: 480px)": {
    "& .mainContainerBox": {
      padding: "15px",
    },

    "& .mainTitleTypo ": {
      fontSize: "18px",
      lineHeight: '22px',
      marginBottom: '5px'
    },

    "& .subConatinerBox": {
      padding: "10px",
    },

    "& .termsTypoText": {
      lineHeight: "20px",
      fontSize: "12px",
    },

    "& .strongSubTitleTypo": {
      fontSize: "14px"
    },

    "& .titletermsTypoText": {
      lineHeight: "20px",
      fontSize: "12px",
    }
  }
});
// Customizable Area End
